import {useMemo} from 'react';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditOrder} from 'services/metadata/metadataEditSlice';

/**
 * Count how many manifestations are in the current work.
 */
export const useManifestationCount = (): number => {
  const expressionOrder = useAppSelector(selectMetadataEditOrder);

  return useMemo(() => {
    return expressionOrder
      .map(g => g.content.filter(c => c.type === 'manifestation').length)
      .reduce((a, b) => a + b, 0);
  }, [expressionOrder]);
};
